import { usePassengerAuthentications } from '@backoffice-frontend/ad-passenger-list'
import { FccPassengerCheckInStatus } from '@backoffice-frontend/graphql/subscription'

import { AuthenticationStatus } from '../PassengerCard/PassengerCard'
import type {
  AdVehicleStreamPassengerCardCustomerInfoFragment,
  AdVehicleStreamPassengerCardSeatInfoFragment,
  AdVehicleStreamPassengerCardStopInfoFragment,
} from '../PassengerCard/PassengerCard.hook'
import { BoardingPassengerCard } from './BoardingPassengerCard'

const FccPassengerCheckInStatusEnumToAuthenticationStatus: Record<
  FccPassengerCheckInStatus,
  AuthenticationStatus
> = {
  [FccPassengerCheckInStatus.ManualPassengerCheckInPending]:
    AuthenticationStatus.MANUAL_PASSENGER_CHECK_IN_PENDING,
  [FccPassengerCheckInStatus.ManualNoShowRequested]:
    AuthenticationStatus.MANUAL_NO_SHOW_REQUESTED,
  [FccPassengerCheckInStatus.NoShowTriggered]:
    AuthenticationStatus.NO_SHOW_TRIGGERED,
  [FccPassengerCheckInStatus.InProgress]: AuthenticationStatus.IN_PROGRESS,
  [FccPassengerCheckInStatus.Confirmed]: AuthenticationStatus.CONFIRMED,
  [FccPassengerCheckInStatus.Cancelled]: AuthenticationStatus.CANCELLED,
  [FccPassengerCheckInStatus.ManualNoShowPending]:
    AuthenticationStatus.MANUAL_NO_SHOW_PENDING,
}

type BoardingPassengerWithAuthenticationProps = {
  tripId: string
  vehicleId: string
  customer: AdVehicleStreamPassengerCardCustomerInfoFragment | null
  waypointStop: AdVehicleStreamPassengerCardStopInfoFragment | null
  seats: AdVehicleStreamPassengerCardSeatInfoFragment
  eta: Date
  isBoarded: boolean
  isNoShow: boolean
}
export const BoardingPassengerCardWithAuthentication = ({
  tripId,
  vehicleId,
  customer,
  waypointStop,
  seats,
  eta,
  isBoarded,
  isNoShow,
}: BoardingPassengerWithAuthenticationProps) => {
  const { getPassengerAuthentication } = usePassengerAuthentications()
  const authenticationStatus = getPassengerAuthentication(tripId)

  return (
    <BoardingPassengerCard
      tripId={tripId}
      vehicleId={vehicleId}
      customer={customer}
      waypointStop={waypointStop}
      seats={seats}
      eta={eta}
      authenticationStatus={
        authenticationStatus
          ? FccPassengerCheckInStatusEnumToAuthenticationStatus[
              authenticationStatus
            ]
          : AuthenticationStatus.UPCOMING
      }
      isNoShow={isNoShow}
      isBoarded={isBoarded}
    />
  )
}
